const initialState = {
  history: { loading: false, error: null, data: [] },
  appLogout: { loading: false, error: null, lastStatus: null, message: "" },
  clearCache: { loading: false, error: null, lastStatus: null, message: "" },
  accountRefresh: { loading: false, error: null, lastStatus: null, data: null, message: "" },
};

export const LIT_CONTROL_HISTORY_REQUEST = "LIT_CONTROL_HISTORY_REQUEST";
export const LIT_CONTROL_HISTORY_SUCCESS = "LIT_CONTROL_HISTORY_SUCCESS";
export const LIT_CONTROL_HISTORY_FAILURE = "LIT_CONTROL_HISTORY_FAILURE";

export const LIT_APP_LOGOUT_REQUEST = "LIT_APP_LOGOUT_REQUEST";
export const LIT_APP_LOGOUT_SUCCESS = "LIT_APP_LOGOUT_SUCCESS";
export const LIT_APP_LOGOUT_FAILURE = "LIT_APP_LOGOUT_FAILURE";
export const LIT_APP_LOGOUT_STATUS = "LIT_APP_LOGOUT_STATUS";
export const LIT_APP_LOGOUT_STATUS_FAILURE = "LIT_APP_LOGOUT_STATUS_FAILURE";

export const LIT_CLEAR_CACHE_REQUEST = "LIT_CLEAR_CACHE_REQUEST";
export const LIT_CLEAR_CACHE_SUCCESS = "LIT_CLEAR_CACHE_SUCCESS";
export const LIT_CLEAR_CACHE_FAILURE = "LIT_CLEAR_CACHE_FAILURE";
export const LIT_CLEAR_CACHE_STATUS = "LIT_CLEAR_CACHE_STATUS";
export const LIT_CLEAR_CACHE_STATUS_FAILURE = "LIT_CLEAR_CACHE_STATUS_FAILURE";

export const LIT_ACCOUNT_REFRESH_REQUEST = "LIT_ACCOUNT_REFRESH_REQUEST";
export const LIT_ACCOUNT_REFRESH_SUCCESS = "LIT_ACCOUNT_REFRESH_SUCCESS";
export const LIT_ACCOUNT_REFRESH_FAILURE = "LIT_ACCOUNT_REFRESH_FAILURE";
export const LIT_ACCOUNT_REFRESH_STATUS = "LIT_ACCOUNT_REFRESH_STATUS";

const normalizeStatusData = (statusData) =>
  statusData?.status === "failed_reception"
    ? { ...statusData, status: "failed" }
    : statusData;

const updateHistoryRow = (data, statusData) => {
  const normalizedStatusData = normalizeStatusData(statusData);
  const rows = data ? [...data] : [];
  const rowIndex = rows.findIndex(
    (row) => row.controlRequestID === normalizedStatusData.controlRequestID
  );

  if (rowIndex === -1) return [normalizedStatusData, ...rows];

  rows[rowIndex] = { ...rows[rowIndex], ...normalizedStatusData };
  return rows;
};

const litControlReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIT_CONTROL_HISTORY_REQUEST:
      return { ...state, history: { loading: true, error: null, data: [] } };
    case LIT_CONTROL_HISTORY_SUCCESS:
      return {
        ...state,
        history: {
          loading: false,
          error: null,
          data: action.payload.map(normalizeStatusData),
        },
      };
    case LIT_CONTROL_HISTORY_FAILURE:
      return { ...state, history: { loading: false, error: action.payload, data: [] } };

    case LIT_APP_LOGOUT_REQUEST:
      return { ...state, appLogout: { loading: true, error: null, lastStatus: null, message: "" } };
    case LIT_APP_LOGOUT_SUCCESS:
      return {
        ...state,
        appLogout: {
          loading: false,
          error: null,
          lastStatus: "sent",
          message: action.message,
        },
      };
    case LIT_APP_LOGOUT_FAILURE:
      return {
        ...state,
        appLogout: {
          loading: false,
          error: action.payload,
          lastStatus: null,
          message: "",
        },
      };
    case LIT_APP_LOGOUT_STATUS:
      return {
        ...state,
        appLogout: {
          ...state.appLogout,
          error: null,
          lastStatus: normalizeStatusData(action.payload).status,
        },
        history: { ...state.history, data: updateHistoryRow(state.history.data, action.payload) },
      };
    case LIT_APP_LOGOUT_STATUS_FAILURE:
      return {
        ...state,
        appLogout: { ...state.appLogout, error: action.payload },
      };

    case LIT_CLEAR_CACHE_REQUEST:
      return { ...state, clearCache: { loading: true, error: null, lastStatus: null, message: "" } };
    case LIT_CLEAR_CACHE_SUCCESS:
      return {
        ...state,
        clearCache: {
          loading: false,
          error: null,
          lastStatus: "sent",
          message: action.message,
        },
      };
    case LIT_CLEAR_CACHE_FAILURE:
      return {
        ...state,
        clearCache: {
          loading: false,
          error: action.payload,
          lastStatus: null,
          message: "",
        },
      };
    case LIT_CLEAR_CACHE_STATUS:
      return {
        ...state,
        clearCache: {
          ...state.clearCache,
          error: null,
          lastStatus: normalizeStatusData(action.payload).status,
        },
        history: { ...state.history, data: updateHistoryRow(state.history.data, action.payload) },
      };
    case LIT_CLEAR_CACHE_STATUS_FAILURE:
      return {
        ...state,
        clearCache: { ...state.clearCache, error: action.payload },
      };

    case LIT_ACCOUNT_REFRESH_REQUEST:
      return {
        ...state,
        accountRefresh: { loading: true, error: null, lastStatus: null, data: null, message: "" },
      };
    case LIT_ACCOUNT_REFRESH_SUCCESS:
      return {
        ...state,
        accountRefresh: {
          loading: false,
          error: null,
          lastStatus: "sent",
          data: action.payload,
          message: action.message,
        },
      };
    case LIT_ACCOUNT_REFRESH_FAILURE:
      return {
        ...state,
        accountRefresh: {
          loading: false,
          error: action.payload,
          lastStatus: null,
          data: null,
          message: action.payload,
        },
      };
    case LIT_ACCOUNT_REFRESH_STATUS:
      return {
        ...state,
        accountRefresh: { ...state.accountRefresh, error: null, lastStatus: action.payload.status },
        history: { ...state.history, data: updateHistoryRow(state.history.data, action.payload) },
      };

    default:
      return state;
  }
};

export default litControlReducer;
